/*jshint globalstrict: false*/

import Vue from 'vue';
import CoffeeIndexHome from '../components/home/coffee-index-home';
import axios from 'axios';

Vue.component('coffee-index-home', CoffeeIndexHome);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="coffee-index-home-vue"]',
    });
});
